var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{class:{active: _vm.isSelected},on:{"click":_vm.selectChannel}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.channelTitle)+" ")]),_c('v-list-item-subtitle',{staticClass:"font-italic text--secondary"},[_vm._v(" "+_vm._s(_vm.channelSubtitle)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }